import React from 'react'
import { Collapse } from 'reactstrap'
import { getStaticImage } from 'utils/statics'
import useCollapsablePlugin from './useCollapsablePlugin'
import CollapsablePluginFilter from './CollapsablePluginFilter'
import './styles.scss'

/**
 * CollapsablePlugin
 * @param {Object} props - Component props
 * @param {string} props.icon - Icon name
 * @param {function} props.onClickCollapse - Function to handle the click event
 * @param {boolean} props.isOpen - State to control the collapse
 * @param {string} props.title - Title of the plugin
 * @param {React.Component} [props.redirectComponent] - Component for redirection (optional)
 * @param {React.Component} [props.filterComponent] - Component for filtering (optional)
 * @param {React.Component} [props.searchComponent] - Component for searching (optional)
 * @param {boolean} [props.disabled] - State to control the disabled (optional)
 * @param {React.Component} [props.children] - Children components (optional)
 */
export const CollapsablePlugin = (props) => {
  const { icon, onClickCollapse, isOpen, title, redirectComponent, filterComponent, searchComponent, disabled, children } = props
  const { filterKey, onToggleFilter, onToggleSearch, onToggleCollapse } = useCollapsablePlugin({ isOpen, onClickCollapse })

  return (
    <div className={`collapsable-plugin ${disabled ? 'disabled' : ''}`}>
      <div
        className={`collapsable-plugin__header ${disabled ? 'disabled' : ''}`}
        onClick={!disabled && onToggleCollapse}
      >
        <div className="collapsable-plugin__header--icon">
          <figure>
            <img src={getStaticImage(`/icons/orange-brand/${icon}.svg`)} alt={`icon-${icon}`} />
          </figure>
          <p>{title}</p>
          {redirectComponent}
        </div>
        <div className="collapsable-plugin__header--action-buttons">
          {filterComponent && <i className={`fa fa-filter ${filterKey === 'filter' ? 'open-icon' : ''}`} onClick={onToggleFilter} />}
          {searchComponent && <i className={`fa fa-search ${filterKey === 'search' ? 'open-icon' : ''}`} onClick={onToggleSearch} />}
          <i className={`fa fa-chevron-${isOpen ? 'up' : 'down'}`} />
        </div>
      </div>
      <Collapse isOpen={isOpen}>
        <CollapsablePluginFilter
          filterKey={filterKey}
          filterComponent={filterComponent}
          searchComponent={searchComponent}
        />
        {children}
      </Collapse>
    </div>
  )
}

export default CollapsablePlugin
